<div class="logo">
  <a class="simple-text logo-mini">
    <div class="logo-img">
      <img src="/assets/img/logo-o2.png" />
    </div>
  </a>
  <a href="https://o2capital.com.br/" target="_blank" class="simple-text logo-normal">
    Capital
  </a>
</div>


<div class="sidebar-wrapper">

  <div class="user">
    <div class="photo">
      <img src="" />
    </div>

    <div class="user-info">
      <a data-toggle="collapse" href="#collapseExample" class="collapsed">
        <span>
          {{ nomeCliente }}
          <b class="caret"></b>
        </span>
      </a>
      <div class="collapse" id="collapseExample">
        <ul class="nav">
          <li class="nav-item" routerLinkActive="active">
            <!-- Corrigido a case sensitivity e adicionado routerLinkActive -->
            <a [routerLink]="['/user']" class="nav-link"> <!-- Substituído href por [routerLink] -->
              <span class="sidebar-mini">MP</span>
              <span class="sidebar-normal">Meu Perfil</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [routerLink]="['/pages/login']" (click)="sair()">
              <span class="sidebar-mini">SA</span>
              <span class="sidebar-normal">Sair</span>
            </a>
          </li>
        </ul>
      </div>

    </div>
  </div>
  <div *ngIf="isMobileMenu()">
    <form class="navbar-form">
      <span class="bmd-form-group">
        <div class="input-group no-border">
          <input type="text" value="" class="form-control" placeholder="Pesquisar...">
          <button mat-raised-button type="submit" class="btn btn-white btn-round btn-just-icon">
            <i class="material-icons">search</i>
            <div class="ripple-container"></div>
          </button>
        </div>
      </span>
    </form>
    <ul class="nav navbar-nav nav-mobile-menu">
      <li class="nav-item dropdown">
        <a class="nav-link" href="#pablo" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true"
          aria-expanded="false">
          <i class="material-icons">notifications</i>
          <span class="notification">2</span>
          <p>
            <span class="d-lg-none d-md-block">Notificações</span>
          </p>
        </a>
        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink">
          <a class="dropdown-item" href="#">O estudo do cliente x vai vencer em 7 dias.</a>
          <a class="dropdown-item" href="#">O estudo do cliente y vai vencer em 3 dias.</a>
        </div>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#pablo">
          <i class="material-icons">person</i>
          <p>
            <span class="d-lg-none d-md-block">Perfil</span>
          </p>
        </a>
      </li>
    </ul>
  </div>
  <ul class="nav">
    <li routerLinkActive="active" *ngFor="let menuitem of menuItems" class="nav-item">
      <!--If is a single link-->
      <a [routerLink]="[menuitem.path]" *ngIf="menuitem.type === 'link' && hasRole(menuitem.min_role)" class="nav-link">
        <i class="material-icons">{{menuitem.icontype}}</i>
        <p>{{menuitem.title}}</p>
      </a>
      <!--If it have a submenu-->
      <a data-toggle="collapse" href="#{{menuitem.collapse}}" id="{{menuitem.collapse}}-p"
        *ngIf="menuitem.type === 'sub' && (hasRole(menuitem.min_role))" (click)="updatePS();expandOrCollapseMenu(menuitem.collapse)" class="nav-link">
        <i class="material-icons">{{menuitem.icontype}}</i>
        <p>{{menuitem.title}}<b class="caret"></b></p>
      </a>

      <!--Display the submenu items-->
      <div id="{{menuitem.collapse}}" class="collapse" *ngIf="menuitem.type === 'sub'">
        <ul class="nav">
          <li routerLinkActive="active" *ngFor="let childitem of menuitem.children" class="nav-item">
            <a *ngIf="(getPageFromLocalStorage() === childitem.page || childitem.page === '') && (hasRole(childitem.min_role))"
              [routerLink]="[menuitem.path, childitem.path]" class="nav-link">
              <span class="sidebar-mini">{{childitem.ab}}</span>
              <span class="sidebar-normal">{{childitem.title}}</span>
            </a>
          </li>
        </ul>
      </div>
    </li>
  </ul>

</div>